import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import { FFTablePaginationProps } from './types';
import { useFFTableStyles } from './styles';

export function FFTablePagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 25, 50, 100],
}: FFTablePaginationProps) {
  const classes = useFFTableStyles();

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage + 1); // Material UI uses 0-based indexing, but our API uses 1-based
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    onPageSizeChange(parseInt(event.target.value, 10));
  };

  return (
    <div className={classes.paginationContainer}>
      <TablePagination
        rowsPerPageOptions={pageSizeOptions}
        component="div"
        count={total}
        rowsPerPage={pageSize}
        page={page - 1} // Convert 1-based to 0-based for Material UI
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}

export default FFTablePagination;
